import { searchSaga } from './SearchEngine'

export const deprecatedSagas = [searchSaga]
